export type DepthTierLabel =
  | 'Platinum'
  | 'Gold'
  | 'Silver'
  | 'Branded'
  | 'Basic';

const getDepthTierLabel = (
  profileTier?: string | null,
  depthTier?: string | null,
): DepthTierLabel | undefined => {
  switch (profileTier) {
    case 'platinum':
      return 'Platinum';
    case 'gold':
      return 'Gold';
    case 'silver':
      return 'Silver';
    case 'branded':
      if (depthTier === 'gold') {
        return 'Gold';
      }
      if (depthTier === 'silver') {
        return 'Silver';
      }
      return 'Branded';
    case 'basic':
      return 'Basic';
    default:
      return undefined;
  }
};

export default getDepthTierLabel;
